import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import Layout from 'components/layout/base';
import PageTitleCard from 'components/page-title-card';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faFilter, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { LoggedUserContext } from 'contexts/logged-user-context';
import lib from '../../helpers/lib';
import RelatorioService from 'services/relatorio-service';
import RepresentadaService from 'services/representada-service';
import Skeleton from 'react-loading-skeleton';
import './styles.scss';
import '../faturamento/styles.scss';

export default function RankingVendedores({ representadas }) {
  const [userData, _] = React.useContext(LoggedUserContext);

  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();
  const dataFinalFiltro = new Date(y, m + 1, 0);

  const [isLoading, setIsLoading] = React.useState(true);

  const [dataMesAnoPassado, setDataMesAnoPassado] = React.useState('');
  const [dataMesPassado, setDataMesPassado] = React.useState('');
  const [vendedores, setVendedores] = React.useState([]);
  const [totalVendedores, setTotalVendedores] = React.useState([]);
  // const [representadas, setRepresentadas] = React.useState([]);

  const [filter, setFilter] = React.useState({
    codigoPedido: '',
    representadaId: null,
    mes: m + 1,
    ano: y
  });

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);

  // useEffect(() => {
  //   (async () => {
  //     // await getRepresentadas();
  //     // getRankingVendedores();
  //   })();
  // }, []);

  useEffect(() => {
    (async () => {
      if (loadedRepresentadas) {
        getRankingVendedores();
      }
    })();
  }, [loadedRepresentadas]);

  useEffect(() => {
    (async () => {
      if (representadas && representadas.length > 0) {
        setFilter((prevFilter) => ({
          ...prevFilter,
          representadaId: representadas[0]?.value
        }));
        setLoadedRepresentadas(true);
      }
    })();
  }, [representadas]);

  useEffect(() => {
    (async () => {
      if (vendedores?.length > 0) {
        let vendedoresComValor = vendedores.filter((item) => item.valorMediaAnual > 0);

        let vendedoresModel = {
          nome: ' ',
          valorAnoAnterior: +vendedores
            .reduce((acc, item) => acc + item.valorAnoAnterior, 0)
            .toFixed(2),
          valorMesAnterior: +vendedores
            .reduce((acc, item) => acc + item.valorMesAnterior, 0)
            .toFixed(2),
          valorMediaAnual:
            +vendedores.reduce((acc, item) => acc + item.valorMediaAnual, 0).toFixed(2) /
            vendedores.length,
          valorMaximoMensal: Math.max(
            ...vendedores.map((item) => {
              return item.valorMaximoMensal;
            })
          ),
          valorFaturado: +vendedores.reduce((acc, item) => acc + item.valorFaturado, 0).toFixed(2),
          valorMeta: +vendedores.reduce((acc, item) => acc + item.valorMeta, 0).toFixed(2),
          valorRealizado: +vendedores.reduce((acc, item) => acc + item.valorRealizado, 0).toFixed(2)
        };

        vendedoresModel.valorRealizado = vendedoresModel.valorFaturado - vendedoresModel.valorMeta;

        vendedoresModel.porcentagemRealizado =
          vendedoresModel.valorMeta != 0
            ? +((vendedoresModel.valorFaturado / vendedoresModel.valorMeta) * 100).toFixed(2)
            : 0;

        setTotalVendedores([vendedoresModel]);
      }
    })();
  }, [vendedores]);

  // useEffect(() => {
  //   (async () => {
  //     let dataMesAnoPassado = `${lib.capitalizeFirstLetter(new Date(filter.ano, filter.mes - 1, 1).toLocaleString('default', { month: 'long' }))} ${y - 1}`;
  //     setDataMesAnoPassado(dataMesAnoPassado);

  //     let dataMesPassado = `${lib.capitalizeFirstLetter(new Date(filter.ano, filter.mes - 2, 1).toLocaleString('default', { month: 'long' }))} ${y}`;
  //     setDataMesPassado(dataMesPassado);
  //   })();
  // }, [filter.ano, filter.mes]);

  async function getRepresentadas() {
    const response = await RepresentadaService.selectListAsync();
    if (response?.data) {
      setRepresentadas(response?.data?.data[0]?.options);
      setFilter({ ...filter, representadaId: response?.data?.data[0]?.options[0]?.value });
    }
  }

  async function getRankingVendedores() {
    setIsLoading(true);

    let resultStatus = await RelatorioService.getRankingVendedores(filter);
    if (resultStatus.data) {
      setVendedores(resultStatus.data);
    }

    setIsLoading(false);
  }

  async function getExtratoRankingVendedores() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoRankingVendedores(filter);

    if (response?.data) {
      let fileName = `faturamento_ranking_vendedores_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data.data, fileName);
    }

    setIsLoading(false);
  }

  return (
    <div>
      {/* Filter ------------------------------------------------------------------------------ */}
      <div className="row filter-bar2 mb-5">
        <div className="col-lg-3">
          <label>Representada</label>
          <Select
            isClearable={false}
            // clearValue={() => {
            //   setFilter({ ...filter, representadaId: null });
            // }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={representadas}
            value={representadas?.find((x) => x.value === filter.representadaId)}
            onChange={(selectedValue) => {
              setFilter({ ...filter, representadaId: selectedValue?.value });
            }}
          />
        </div>

        <div className="col-lg-2">
          <label>Mês</label>
          <Select
            className="select-form-control"
            value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
            options={lib.selectListMeses}
            isClearable={false}
            onChange={(item) => {
              setFilter({ ...filter, mes: item.value });
            }}
          />
        </div>

        <div className="col-lg-2">
          <label>Ano</label>
          <Select
            className="select-form-control"
            value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
            options={lib.selectListAnos}
            isClearable={false}
            onChange={(item) => {
              setFilter({ ...filter, ano: item.value });
            }}
          />
        </div>

        <div className="col row">
          <div className="col-xl-6"></div>

          <div className="col-xl-3 col-6 align-content-end">
            {/* Botão Exportar --------------------------------------------------------------------- */}
            <button
              type="button"
              className="btn btn-secondary btn-sm btn-action"
              onClick={() => {
                setFilter({
                  ...filter
                });
                getExtratoRankingVendedores();
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faFileExcel} /> Exportar
            </button>
          </div>

          <div className="col-xl-3 col-6 align-content-end">
            <button
              type="button"
              className="btn btn-secondary btn-sm btn-action"
              onClick={() => {
                setFilter({
                  ...filter
                  //pageNumber: 1
                });
                getRankingVendedores();
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faFilter} /> Filtrar
            </button>
          </div>
        </div>
      </div>

      {/* Lista Representadas ----------------------------------------------------------------- */}
      <div className="table-responsive table-historico mt-4" onCopy={(e) => lib.parseCopiedText(e)}>
        {!isLoading && vendedores ? (
          <Table striped bordered hover width="100%" className="table-relatorio">
            <thead>
              <tr>
                <th>Vendedor</th>
                {/* <th>{dataMesAnoPassado}</th>
                <th>{dataMesPassado}</th> */}
                <th>Ano Anterior</th>
                <th>Mês Anterior</th>
                <th>Média 12M</th>
                <th>Máx (12 meses)</th>
                <th>Faturado</th>
                <th>Objetivo</th>
                <th colSpan={2} className="text-center">
                  Realizado
                </th>
              </tr>
            </thead>
            {/* <tbody className="table-sem-totalizadores"> */}
            <tbody>
              {vendedores.length > 0 ? (
                ([...vendedores, ...totalVendedores] || [])?.map((item, index) => (
                  <tr key={index} className={index >= vendedores.length ? 'fw-700' : ''}>
                    <td>{item.nome}</td>
                    <td>
                      {/* {item.valorAnoAnterior.toFixed(2)} */}
                      {Math.floor(item.valorAnoAnterior).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                      {/* <span> ({item.porcentagemAnoAnterior}%)</span> */}
                    </td>
                    <td>
                      {/* {item.valorMesAnterior.toFixed(2)} */}
                      {Math.floor(item.valorMesAnterior).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                      {/* <span> ({item.porcentagemMesAnterior}%)</span> */}
                    </td>
                    <td>
                      {/* {item.valorMediaAnual.toFixed(2)} */}
                      {Math.floor(item.valorMediaAnual).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                      {/* <span> ({item.porcentagemMediaAnual}%)</span> */}
                    </td>
                    <td>
                      {/* {item.valorMaximoMensal.toFixed(2)} */}
                      {Math.floor(item.valorMaximoMensal).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                      {/* <span> ({item.porcentagemMaximoMensal}%)</span> */}
                    </td>
                    <td>
                      {/* {item.valorFaturado.toFixed(2)} */}
                      {Math.floor(item.valorFaturado).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </td>
                    <td>
                      {/* {item.valorMeta.toFixed(2)} */}
                      {Math.floor(item.valorMeta).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </td>
                    <td className={item.valorRealizado < 0 ? 'txt-red' : 'txt-green'}>
                      {/* {(item.valorMeta > 0 ? item.valorRealizado : 0).toFixed(2)} */}
                      {Math.floor(item.valorMeta > 0 ? item.valorRealizado : 0).toLocaleString(
                        'pt-br',
                        {
                          style: 'currency',
                          currency: 'BRL',
                          maximumFractionDigits: 0
                        }
                      )}
                    </td>
                    <td
                      style={{ textAlign: 'center' }}
                      className={
                        item.porcentagemRealizado < 100 && item.valorMeta != 0
                          ? 'txt-red'
                          : 'txt-green'
                      }
                    >
                      {lib.formatToNumeric(item.porcentagemRealizado, 2, true)}%
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9}>Nenhum registro encontrado.</td>
                </tr>
              )}
            </tbody>
          </Table>
        ) : (
          <Skeleton count={10} />
        )}
      </div>
    </div>
  );
}
